import { BaseController } from '../../../../../../../common/base/controller';

const CONTACT_CUSTOMER_FOR_INQUIRIES = 'contactCustomerForInquiries';
const CONTANT_BANK_FOR_INQUIRIES = 'contactBankForInquiries';

export class RBAustriaController extends BaseController {
  constructor($scope, $compile, controllerService) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
    });

    this.ibanInputOptions = { type: 'text', validate: 'iban' };
    this.ibanErrorMessages = {
      required: 'receiving.createRequest.form.accountToBeClosed.error.required',
      iban: 'receiving.createRequest.form.error.accountToBeClosed.iban',
      type: 'receiving.createRequest.form.error.accountToBeClosed.type',
    };

    this.accountClosingDateMessages = {
      parse: 'receiving.createRequest.form.error.dateInvalid',
      required: 'receiving.createRequest.form.error.required',
      min: 'receiving.createRequest.form.error.minDate',
    };
  }

  get showBankContactSection() {
    return this.model.contactForInquiries == 'contactBankForInquiries';
  }

  removeClosingAccount(index) {
    this.model.additionalAccounts.additionalClosingAccounts.splice(index, 1);
  }

  get canNotBeAdded() {
    return !this.accountToBeClosed;
  }

  clear() {
    this.accountToBeClosed = '';
  }

  addClosingAccount() {
    this.model.additionalAccounts.additionalClosingAccounts.push(
      this.accountToBeClosed,
    );
    this.clear();
  }

  $onInit() {
    this.model.additionalAccounts = {
      additionalClosingAccounts: [],
      closeAdditionalAccounts: false,
    };

    this.dateOptions = this.dateOptions = {
      dateFormat: this.languageOptions.dateFormat,
      minDate: new Date(),
    };

    this.model.contactForInquiries = CONTANT_BANK_FOR_INQUIRIES;

    this.contactTypes = [
      CONTACT_CUSTOMER_FOR_INQUIRIES,
      CONTANT_BANK_FOR_INQUIRIES,
    ];
  }
}
